import Vue from 'vue'
import VueRouter from 'vue-router'
import Experience from './components/Experience.vue'
import Pragmem from './components/Pragmem.vue'
import Contacts from './components/Contacts.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  //base: "/present-experience/",
  base: "/",
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Experience',
      component: Experience,
      redirect: '/Experience',
      meta: { title: 'Выставка «Опыт настоящего»' }
    },
    {
      path: '/Experience',
      name: 'Experience',
      component: Experience,
      meta: { title: 'Выставка «Опыт настоящего»' }
    },
    {
      path: '/Pragmem',
      name: 'Pragmem',
      component: Pragmem,
      meta: { title: 'Проект Прагмема' }
    },
    {
      path: '/Contacts',
      name: 'Contacts',
      component: Contacts,
      meta: { title: 'Контакты' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router